/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/de'



import {Notify,AppFullscreen,BottomSheet} from 'quasar'



export default { config: {"notify":{"color":"primary","position":"bottom-left"}},lang,plugins: {Notify,AppFullscreen,BottomSheet} }

